
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import GlobalStore from '@/store/modules/global';

@Component({ name: 'UserGuide' })
export default class UserGuide extends Vue {
    private globalStore = getModule(GlobalStore, this.$store);
    public userGuideUrl : string = process.env.VUE_APP_USER_GUIDE_URL || "https://pdfobject.com/pdf/sample.pdf";
}
